module.exports = __webpack_public_path__ + "static/img/nao-avatar.7e2b200.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/nao-avatar.png
// module id = 6LwK
// module chunks = 1